// REACT
import React, { ChangeEvent, RefObject, useRef, useEffect, FocusEvent } from 'react'

// ESTILOS
import Styles from './Input.module.css'

// CODIGOS DE REGION Y STRINGS
import Codes from 'Utils/CountryCodes.json'
import Strings from 'Lang/Strings.json'

// PROPIEDADES
interface InputProps {
	name: string
	placeholder: string
	firstRender?: boolean
	setError?: boolean
	type?: string
	defValue?: string
	options?: string[]
	clearData?: boolean
	index?: number
	onBlur?: (value: string, name: string) => any
	getData: (value: string, name: string) => any
}

const Input: React.FC<InputProps> = (props: InputProps) => {
	// REFERENCIAS
	const flag: RefObject<HTMLImageElement> = useRef(null)
	const input: RefObject<HTMLInputElement> = useRef(null)
	const select: RefObject<HTMLSelectElement> = useRef(null)

	// CAMBIAR BANDERA
	const changeFlag = (ev: ChangeEvent<HTMLSelectElement>) => {
		// OBTENER PHONE CODE
		const value: string | null = ev.target.value

		// OBTENER COUNTRY CODE
		const cCode: string[] | undefined = Codes.codes.find(
			(country: string[]) => country[1] === value
		)

		// VERIFICAR QUE EXISTE CODE

		if (flag.current && cCode) {
			// CAMBIAR BANDERA
			flag.current.src = `https://www.countryflags.io/${cCode[0].toLowerCase()}/flat/24.png`
			flag.current.alt = `${cCode[0]} Flag`

			// ENVIAR CAMBIO
			props.getData(cCode.join(' '), 'region')
		}
	}

	// ENVIAR DATOS (RETORNO)
	const processData = (ev: any, func: (value: string, name: string) => any) => {
		if (props.options) {
			// OBTENER INDEX
			const selectEl: HTMLSelectElement = ev.target as HTMLSelectElement
			const index: number = selectEl.selectedIndex
			const options: string[] | undefined =
				Strings.es.reservation.form.inputs[props.index || 0].options

			// ENVIAR INDEX
			func(options ? options[index] : '', props.name)
		} else func(ev.target.value, props.name)
	}

	const sendData = (ev: ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
		processData(ev, props.getData)
	const saveData = (ev: FocusEvent<HTMLInputElement | HTMLSelectElement>) => {
		if (props.onBlur) processData(ev, props.onBlur)
	}

	// VALORES POR DEFECTO
	useEffect(() => {
		const clearData = () => {
			// LIMPIAR DATOS
			if (input.current) input.current.value = props.defValue || ''
			if (select.current) select.current.value = props.defValue || ''
		}

		// VERIFICAR SI SE PUEDEN LIMPIAR LOS DATOS
		if (props.clearData) clearData()
		if (props.firstRender) clearData()
	}, [props.defValue, props.clearData, props.firstRender])

	return (
		<div className={Styles.container}>
			{props.type === 'phone' && (
				<>
					<img
						className={Styles.optionIcon}
						src='https://www.countryflags.io/gt/flat/24.png'
						alt='GT Flag'
						ref={flag}
					/>
					<select className={Styles.number} defaultValue='502' onChange={changeFlag}>
						{Codes.codes.map((code: string[], index: number) => (
							<option value={code[1]} key={index}>
								{code[1]}
							</option>
						))}
					</select>
				</>
			)}
			{!props.options ? (
				<input
					ref={input}
					type={props.type === 'phone' ? 'number' : props.type}
					id={props.name}
					name={props.name}
					className={`${props.type === 'phone' ? Styles.phInp : ''} ${Styles.input} ${
						!props.firstRender ? (!props.setError ? Styles.errorInput : Styles.normalInput) : ''
					}`}
					style={{ width: props.type === 'phone' ? '153px' : '250px' }}
					placeholder={props.placeholder}
					onChange={sendData}
					onBlur={saveData}
				/>
			) : (
				<select
					onBlur={saveData}
					ref={select}
					className={Styles.select}
					onChange={sendData}
					defaultValue={props.defValue}>
					{props.options.map((opt: string, key: number) => (
						<option value={opt} key={key}>
							{opt}
						</option>
					))}
				</select>
			)}
		</div>
	)
}

export default Input
